
export default {
  data() {
    return {
      possibility: [
        {
          name: "مشاهده لحظه‌ای منابع و زیرساخت‌ها",
          img: "Api.701b548 2.svg",
          alt: "مشاهده منابع در پنل دیتاسنتر ابری آبالون",
          title: "مشاهده منابع در پنل دیتاسنتر ابری",
        },

        {
          name: "مدیریت توپولوژی شبکه",
          img: "NetworkTopology.3e287eb 1.svg",
          alt: "مدیریت توپولوژی شبکه در پنل دیتاسنتر ابری آبالون",
          title: "مدیریت توپولوژی شبکه در پنل دیتاسنتر ابری",
        },
        {
          name: "مدیریت یکپارچه ماشین‌های مجازی",
          img: "VirtualMachins.217b5d7 1.svg",
          alt: "مدیریت ماشین‌های مجازی در پنل دیتاسنتر ابری آبالون",
          title: "مدیریت ماشین‌های مجازی در پنل دیتاسنتر ابری",
        },
        {
          name: "پیاده‌سازی Load Balancer",
          img: "LoadBalancers.4b40924 1.svg",
          alt: "پیاده‌سازی لود بالانسر در پنل وی پی سی",
          title: "پیاده‌سازی لود بالانسر در پنل وی پی سی",
        },

        {
          name: "نظارت بر معماری زیرساخت",
          img: "CloudCanvas.82fd9ce 1.svg",
          alt: "معماری زیرساخت در پنل وی پی سی",
          title: "معماری زیرساخت در پنل وی پی سی",
        },
        {
          name: "مدیریت فایروال پیشرفته",
          img: "Firewall.398439d 1.svg",
          alt: "مدیریت پیشرفته فایروال در پنل وی پی سی",
          title: "مدیریت پیشرفته فایروال در پنل وی پی سی",
        },
        {
          name: "مدیریت دیسک‌های مجازی ",
          img: "Volumes.d769ca6 1.svg",
          alt: "مدیریت دیسک مجازی در پنل وی پی سی",
          title: "مدیریت دیسک مجازی در پنل وی پی سی",
        },
      ],
      activeIndex: 0,
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
